import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { stringify } from 'qs';

var updatePageNumber = function updatePageNumber(query) {
  if (window.history.pushState) {
    var path = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(stringify(query));
    window.history.replaceState({
      path: path
    }, '', path);
  }
};

export default updatePageNumber;